<template>
  <v-card elevation="3" style="width: 100%; min-height: 500px">
    <v-row no-gutters class="mx-2">
      <!-- Button -->
      <v-col cols="12">
        <v-row justify="end" no-gutters>
          <v-btn
            class="btn-primary"
            color="primary"
            @click="toggleImportDialog(true)"
          >
            {{ $t("studies.tabs.files.buttons.add") }}
          </v-btn>
        </v-row>
      </v-col>

      <!-- Files Datatable -->
      <v-col cols="12">
        <FilesDatatable v-if="!showDialog.import" :URL_API="URL_API" />
      </v-col>
    </v-row>

    <!-- Upload dialog -->
    <UploadFileDialog
      v-if="showDialog.import"
      :value="showDialog.import"
      :URL_API="URL_API.UPLOAD"
      @close="(needRefresh) => toggleImportDialog(false, needRefresh)"
    />
  </v-card>
</template>

<script>
export default {
  name: "ProductFilesTab",

  components: {
    UploadFileDialog: () =>
      import("@/components/Common/Files/UploadFileDialog"),
    FilesDatatable: () => import("@/components/Common/Files/FilesDatatable"),
  },

  mixins: [],

  props: {
    study: { type: Object, default: () => null, required: true },
  },

  data() {
    return {
      showDialog: {
        import: false,
      },

      URL_API: {
        GET_ALL: `/studies/${this.study.id}/files`,
        UPLOAD: `/studies/${this.study.id}/files`,
        DELETE: `/studies/${this.study.id}/files`,
        DOWNLOAD: `/studies/${this.study.id}/files`,
      },
    };
  },

  methods: {
    toggleImportDialog(val, needRefresh = false) {
      this.showDialog.import = val;
    },
  },
};
</script>

<style scoped></style>
